import React from 'react';
import mermaid from 'mermaid';
import svgPanZoom from 'svg-pan-zoom';
import { Box } from '@mui/material';

interface MermaidProps {
  chart: string;
}

function stripSvgMaxWidth(svg: SVGSVGElement): void {
  const styleEl = svg.querySelector('style');
  if (styleEl?.textContent) {
    styleEl.textContent = styleEl.textContent.replace(/\s*max-width:\s*[\d.]*px;/gi, '');
  }
  const attr = svg.getAttribute('style');
  if (attr) {
    svg.setAttribute('style', attr.replace(/\s*max-width:\s*[\d.]*px;?/gi, ''));
  }
}

mermaid.initialize({
  startOnLoad: false,
  securityLevel: 'loose',
  htmlLabels: false,
});

export default class Mermaid extends React.Component<MermaidProps> {
  private containerRef = React.createRef<HTMLDivElement>();
  private panZoomInstance: ReturnType<typeof svgPanZoom> | null = null;

  componentDidMount() {
    this.runMermaid();
  }

  componentDidUpdate(prevProps: MermaidProps) {
    if (prevProps.chart !== this.props.chart) {
      this.runMermaid();
    }
  }

  componentWillUnmount() {
    this.destroyPanZoom();
  }

  private destroyPanZoom() {
    if (this.panZoomInstance) {
      this.panZoomInstance.destroy();
      this.panZoomInstance = null;
    }
  }

  private runMermaid() {
    const node = this.containerRef.current;
    if (!node || !this.props.chart.trim()) return;

    this.destroyPanZoom();

    mermaid
      .run({ nodes: [node], suppressErrors: true })
      .then(() => {
        const svg = node.querySelector('svg');
        if (svg) {
          stripSvgMaxWidth(svg);
          this.panZoomInstance = svgPanZoom(svg, {
            zoomEnabled: true,
            panEnabled: true,
            controlIconsEnabled: true,
            fit: true,
            center: true,
          });
        }
      })
      .catch(() => {});
  }

  render() {
    const { chart } = this.props;
    return (
      <Box
        ref={this.containerRef}
        className="mermaid nodrag nopan"
        sx={{
          width: '100%',
          minHeight: 200,
          height: 360,
          overflow: 'auto',
          resize: 'vertical',
        }}
      >
        {chart}
      </Box>
    );
  }
}
